import { Provider, observer } from 'mobx-react';
import React from 'react';

import FractionsStore from 'productionOrders/stores/FractionsStore';
import type {
  BagWeightSource,
  FractionsExpansionOptions,
} from 'productionOrders/stores/FractionsStore';
import FractionsComponent from 'productionOrders/components/FractionsComponent';
import OverlayStore from 'stores/OverlayStore';
import RoastingResult from 'types/utils/roastingResult';
import { ReasonGet } from 'types/model/reason';

import FractionType from 'types/model/fraction';
import MillingMachineType from 'types/model/millingMachine';

export interface FractionsContainerProps {
  estimatedWeight: number;
  maxWeight: string;
  fractions: FractionType[];
  roastingResults: RoastingResult[];
  roastingValidations: { pppt: { min: number; max: number } };
  humidityAnalysisAcceptingReasons: ReasonGet[];
  machines: MillingMachineType[];
  run: number;
  createdAt: string;
  cuppingSessionEnabled: boolean;
  id?: number;
  bagWeightKg?: number | null;
  bagWeightSource?: BagWeightSource | null;
  // PLA-860 v2: el contenedor de la trilla crea el store para leer las subdivisiones pendientes.
  fractionsStore?: FractionsStore;
}

export const buildFractionsStore = (
  {
    estimatedWeight,
    maxWeight,
    fractions,
    roastingResults,
    roastingValidations,
    humidityAnalysisAcceptingReasons,
    machines,
    bagWeightKg,
    bagWeightSource,
  }: FractionsContainerProps,
  expansion?: FractionsExpansionOptions
): FractionsStore =>
  new FractionsStore(
    estimatedWeight,
    maxWeight,
    fractions,
    roastingResults,
    roastingValidations,
    humidityAnalysisAcceptingReasons,
    machines,
    bagWeightKg,
    bagWeightSource,
    expansion
  );

function FractionsContainer(props: FractionsContainerProps): JSX.Element {
  const { run, createdAt, cuppingSessionEnabled, fractionsStore } = props;

  return (
    <Provider
      fractionsStore={fractionsStore || buildFractionsStore(props)}
      overlayStore={new OverlayStore()}
    >
      <FractionsComponent
        run={run}
        createdAt={createdAt}
        cuppingSessionEnabled={cuppingSessionEnabled}
      />
    </Provider>
  );
}

export default observer(FractionsContainer);
